import cn from 'classnames'
import Image from 'next/image'
import React from 'react'
import { HtmlContentViewer } from 'src/components/global/HtmlContentViewer/HtmlContentViewer'
import VendorLogo from 'src/components/global/VendorLogo/VendorLogo'
import { ICompanyDataFragment } from 'src/graphql/generated/hooks'
import { useDefaultLogo } from 'src/hooks/useDefaultLogo'

import { ThemeOnly } from '../global/ThemeOnly'
interface CompanyHeaderProps {
  className?: string
  company: ICompanyDataFragment
}

/**
 * Primary UI component for user interaction
 */
export const CompanyHeader: React.FC<CompanyHeaderProps> = ({ className, company }) => {
  const logo = useDefaultLogo(company.attributes?.logo?.data?.attributes?.url)
  const name = company.attributes?.name || ''
  const description = company.attributes?.description || ''

  let iltaSponsorshipLogo = ''
  if ((company.attributes?.iltaSponsorships?.data || []).length > 0) {
    iltaSponsorshipLogo = company.attributes?.iltaSponsorships?.data[0].attributes?.logo?.data?.attributes?.url || ''
  }

  return (
    <div className={cn(className, 'flex flex-row justify-center bg-clouds')}>
      <div className="mobile-hide w-full">
        <div className="flex flex-row justify-center">
          <div className="flex flex-col md:pl-[0px] pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full pt-2 mt-[0.9375rem]  mb-[2.125rem]">
            <div className="flex flex-row sm:grid-cols-2 w-full">
              <VendorLogo className="mr-[1.6875rem]" alt={name} src={logo} />
              <div className="self-center w-full">
                <div className="flex flex-row">
                  <div className="flex flex-col flex-auto">
                    <div className="flex flex-col">
                      <div className="pt-[0.1rem] pb-[0.125rem] font-bold font-secondary text-darkgray text-[1.875rem]">
                        {name} - Company
                      </div>
                      <HtmlContentViewer
                        className="text-[0.9375rem] font-primary font-regular text-darkgray "
                        html={description}
                      />
                    </div>
                  </div>
                  <ThemeOnly theme="ilta">
                    <div className="flex w-full flex-col">
                      {iltaSponsorshipLogo && (
                        <div className="ml-auto">
                          <Image
                            src={iltaSponsorshipLogo}
                            width={100}
                            height={100}
                            className="w-[100px] h-auto mt-[20px]"
                            alt={''}
                          />
                        </div>
                      )}
                    </div>
                  </ThemeOnly>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
